// Module
var code = " <template> <require from=\"app/cm/admin/referral/reasons-for-referral\"></require> <reasons-for-referral></reasons-for-referral> </template> ";
// Exports
module.exports = code;